'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { useAirbridgeContext } from '@/shared/config'
import { cn, isNilOrEmptyString, Slot, useFormatDate } from '@/shared/lib'
import { Icon, TextField } from '@/shared/ui'

export const MobileSearchBar = () => {
  const t = useTranslations('map')

  const { formatDate } = useFormatDate()

  const { startDate, endDate } = useSearchFilterStore(state => state.filters)

  const dateInputValue = useMemo(() => {
    if (isNilOrEmptyString(startDate) || isNilOrEmptyString(endDate)) return ''

    return `${formatDate({ date: startDate, format: 'MM.dd' })} - ${formatDate({ date: endDate, format: 'MM.dd' })}`
  }, [startDate, endDate])

  const airbridge = useAirbridgeContext()

  const handleClick = () => {
    airbridge.openDeeplink()
  }

  return (
    <div className="flex h-[57px] gap-4 border-b border-b-gray-100 bg-white px-4 py-[3px]">
      {/* TODO: X 버튼 제거 가능하도록 TextField 수정 */}
      <TextField
        readOnly
        placeholder={t('search.location.mobile_placeholder')}
        onClick={handleClick}
        className="w-3/5 border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]! *:placeholder:text-gray-400"
        padding={{
          x: 0,
          y: 13,
        }}
      >
        <Slot name="left">
          <Icon
            name="search"
            size={24}
            className="text-black"
            strokeWidth={1.5}
          />
        </Slot>
      </TextField>
      {/* TODO: 모바일용 PeriodPicker 컴포넌트 추가 */}
      <TextField
        value={dateInputValue}
        readOnly
        placeholder={t('search.date.mobile_placeholder')}
        onClick={handleClick}
        tabIndex={-1}
        type="text"
        className={cn(
          'cursor-pointer border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]!',
          '*:placeholder:text-gray-400 *:read-only:cursor-pointer',
          'w-2/5 shrink-0 focus-visible:outline-none',
        )}
        padding={{
          x: 0,
          y: 13,
        }}
      >
        <Slot name="left">
          <Icon
            name="calendar"
            className="text-black"
            size="24"
            strokeWidth={1.5}
          />
        </Slot>
      </TextField>
    </div>
  )
}
